// pages/employer/SentLetters.jsx
import { useEffect, useState } from 'react';
import axios from 'axios';
import SendNotificationModal from './SendNotification';

const SentLetters = () => {
  const [letters, setLetters] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLetters = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}notification/my-sent`,
          {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          }
        );
        setLetters(res.data.data || []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchLetters();
  }, []);

  if (loading) return <div className="p-8 text-center">Loading sent letters...</div>;

  return (
    <div className="max-w-5xl mx-auto px-4 py-8">
        <SendNotificationModal/>
      <h1 className="text-2xl md:text-3xl font-bold mb-8">Sent Notification Letters</h1>

      {letters.length === 0 ? (
        <div className="text-center py-12 text-gray-500">
          You haven't sent any notification letters yet.
        </div>
      ) : (
        <div className="space-y-5">
          {letters.map(letter => (
            <div
              key={letter._id}
              className="border rounded-xl p-5 md:p-6 bg-white shadow-sm hover:shadow-md transition"
            >
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-4">
                <div>
                  <h3 className="font-semibold text-lg text-orange-700">
                    {letter.title}
                  </h3>
                  <p className="text-sm text-gray-600 mt-1">
                    To: {letter.recipient?.firstName} {letter.recipient?.lastName}
                  </p>
                  <p className="text-sm text-gray-500">
                    {letter.type.replace('_', ' ').toUpperCase()}
                  </p>
                </div>
                <div className="text-sm text-gray-500 whitespace-nowrap">
                 { new Date(letter.createdAt).toLocaleDateString()}
                </div>
              </div>

              <div className="mt-4 p-4 bg-gray-50 rounded-lg border text-sm leading-relaxed whitespace-pre-line">
                {letter.message}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SentLetters;